"use strict";

var _classCallCheck = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/fceller/ArangoDB/oskar/work/ArangoDB/js/apps/system/_admin/aardvark/APP/react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var error_1 = require("./error");

var ANALYZER_NOT_FOUND = 1202;

var ArangoAnalyzer = /*#__PURE__*/function () {
  function ArangoAnalyzer(connection, name) {
    _classCallCheck(this, ArangoAnalyzer);

    this.isArangoAnalyzer = true;
    this._connection = connection;
    this.name = name;
  }

  _createClass(ArangoAnalyzer, [{
    key: "get",
    value: function get() {
      return this._connection.request({
        path: "/_api/analyzer/".concat(this.name)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "exists",
    value: function exists() {
      return this.get().then(function () {
        return true;
      }, function (err) {
        if (error_1.isArangoError(err) && err.errorNum === ANALYZER_NOT_FOUND) {
          return false;
        }

        throw err;
      });
    }
  }, {
    key: "create",
    value: function create(options) {
      return this._connection.request({
        method: "POST",
        path: "/_api/analyzer",
        body: Object.assign({
          name: this.name
        }, options)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "drop",
    value: function drop(force) {
      return this._connection.request({
        method: "DELETE",
        path: "/_api/analyzer/".concat(this.name),
        qs: {
          force: force
        }
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return ArangoAnalyzer;
}();

exports.ArangoAnalyzer = ArangoAnalyzer;